export const siteUrlWithoutHttps = "artpavlushin.ru";

export const helpLink = "https://t.me/ArtPavlushinSupportBot";

export const errorLink = "https://www.youtube.com/shorts/cd2FbHV8gx8";
